require("./index.marko.scss");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        this.state = {
            original: 'en',
            editable: uiStore.get('t-stack-editable'),
            tosave: false,
            expand: false,
            counter: 0,
            newRecords: [],
            language: {},
            variants: [],
            activeVariant: uiStore.get('t-stack-var'),
            translation: '',
            loading: false,
            saving: false
        };
        GState.bind(this, [
            'DCR',
            'locale'
        ]);
        GState.on('DCR', this.checkNewRecords.bind(this));
        this.onSelect('locale', uiStore.get('t-stack-lang') || 'en');
    },
    onMount: async function () {
        await this.fetchDictionaries(newObject(Languages));
    },
    onExpand: function () {
        (this.state.expand = !this.state.expand) && this.onEdit(false);
    },
    onSelect: function (type, value) {
        switch (type) {
        case 'locale': {
                for (let x in Languages)
                    if (value == Languages[x].locale) {
                        this.state.language = Languages[x];
                        uiStore.set('t-stack-lang', value);
                        this.state.variants = Object.entries(Languages[x].variants).map(([key, name]) => {
                            return {
                                id: key,
                                name
                            };
                        });
                        this.state.activeVariant = this.state.variants[0].id;
                        this.state.editable && this.onEdit(this.state.editable);
                        break;
                    }
            }
            break;
        case 'variant': {
                this.state.activeVariant = value;
                uiStore.set('t-stack-var', value);
                this.state.editable && this.onEdit(this.state.editable);
            }
            break;
        }
    },
    onEdit: function (text) {
        if (text === false) {
            this.state.editable = false;
            uiStore.clear('t-stack-editable');
            return;
        }
        uiStore.set('t-stack-editable', this.state.editable = text);
        if (!this.checkRequirement())
            return;
        const translation = Dictionaries[this.state.language.locale][text];
        if (!translation) {
            if (this.state.original == this.state.language.locale)
                this.state.translation = text;
            return;
        }
        this.state.translation = typeof translation == 'object' ? translation[this.state.activeVariant] : translation;
    },
    onError: function (error) {
        this.state.error = error;
        error && setTimeout(() => this.state.error = false, 12000);
    },
    onTranslateChange: function (e) {
        if (!this.checkRequirement())
            return;
        const translation = this.state.translation = e.target.value || e.target.innerText, existingTranslation = Dictionaries[this.state.language.locale][this.state.editable];
        if (existingTranslation) {
            const hasVariants = typeof existingTranslation == 'object';
            if (hasVariants && existingTranslation[this.state.activeVariant] == translation || translation == existingTranslation)
                return;
            this.state.tosave = true;
            if (!hasVariants)
                Dictionaries[this.state.language.locale][this.state.editable] = {};
            Dictionaries[this.state.language.locale][this.state.editable][this.state.activeVariant] = translation;
        } else {
            this.state.tosave = true;
            Dictionaries[this.state.language.locale][this.state.editable] = { [this.state.activeVariant]: translation };
        }
    },
    checkNewRecords: function (DCR) {
        if (!Dictionaries[this.state.original])
            return;
        DCR.map(each => {
            if (Dictionaries[this.state.original][each])
                return;
            Dictionaries[this.state.original][each] = { [this.state.activeVariant]: each };
            this.state.counter++;
            this.state.newRecords.push(each);
            this.setStateDirty('newRecords');
        });
        if (this.state.counter)
            this.state.tosave = true;
    },
    checkRequirement: function () {
        if (isEmpty(this.state.language)) {
            this.onError('No language selected');
            return false;
        }
        if (!Dictionaries[this.state.language.locale]) {
            this.onError(`${ this.state.language.name } is not supported`);
            return false;
        }
        return true;
    },
    fetchDictionaries: async function (list) {
        if (!Array.isArray(list) || !list.length)
            return;
        const {locale, name} = list.shift();
        this.state.loading = `Loading ${ name } dictionary`;
        try {
            Dictionaries[locale] = await AppRequest('/translation/' + locale);
        } catch (error) {
            console.log(`Failed to load ${ name } dictionary: `, error);
        }
        if (list.length) {
            await this.fetchDictionaries(list);
            return;
        }
        this.checkNewRecords(this.state.DCR);
        this.state.loading = false;
    },
    onSave: async function () {
        this.state.saving = true;
        try {
            const lang = this.state.language.locale, {error, message} = await AppRequest(`/translation/${ lang }`, 'PUT', Dictionaries[lang]);
            if (error)
                throw new Error(message);
            this.setState({
                tosave: false,
                counter: 0,
                newRecords: []
            });
            this.checkNewRecords(this.state.DCR);
            GState.locale.switch(`${ this.state.locale.language }-${ this.state.locale.variant }`);
        } catch (error) {
            console.log('Failed saving changes: ', error);
            this.onError(error.message);
        }
        this.state.saving = false;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/TranslateTrack/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_Languages = require("json/languages"),
    Languages = module_Languages.default || module_Languages,
    Locale_template = require("../Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Preloader_template = require("../Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Bx_template = require("../Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    Select_template = require("../Select/index.marko"),
    Select_tag = marko_loadTag(Select_template),
    Row_template = require("../Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    marko_attrs0 = {
        "class": "t-stack-block position-fixed right-0 bottom-0 p-2 m-4"
      },
    marko_attrs1 = {
        "class": "t-stack-toggle position-fixed right-0 bottom-0 p-50 m-4 theme-bg-primary d-flex align-items-center round shadow-lg cursor-pointer"
      },
    marko_attrs2 = {
        "class": "t-stack-header position-relative px-2 py-1 border-bottom d-flex align-items-center"
      },
    marko_attrs3 = {
        "class": "t-stack-content overflow-auto"
      },
    marko_attrs4 = {
        "class": "btn btn-primary round position-absolute right-0 mx-2"
      },
    marko_attrs5 = {
        "class": "list-unstyled m-0"
      },
    marko_attrs6 = {
        "class": "h-75 d-flex align-items-center"
      },
    marko_attrs7 = {
        "class": "w-100 text-center"
      },
    marko_attrs8 = {
        "class": "px-2 py-1 d-flex align-items-center"
      },
    marko_attrs9 = {
        "class": "t-stack-header position-relative px-2 py-1 border-bottom d-flex align-items-center"
      },
    marko_attrs10 = {
        "class": "t-stack-content"
      },
    marko_attrs11 = {
        "class": "position-relative h-100 px-2 py-1"
      },
    marko_attrs12 = {
        style: "height:80%",
        "class": "my-2"
      },
    marko_attrs13 = {
        "class": "py-25"
      },
    marko_attrs14 = {
        "class": "btn btn-primary round position-absolute right-0 mx-2"
      },
    marko_attrs15 = {
        "class": "py-25"
      },
    marko_attrs16 = {
        "class": "py-25"
      },
    marko_attrs17 = {
        style: "margin-left:5px"
      },
    marko_attrs18 = {
        "class": "t-stack-counter white black-text font-weight-500 d-flex align-items-center text-center rounded-circle"
      },
    marko_attrs19 = {
        "class": "w-100 text-center black-text px-25"
      };

const Dictionaries = {};

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("div", {
      "class": marko_classValue(marko_classValue([
        "t-stack-body position-relative only-dark-bg-fade round shadow-lg overflow-hidden",
        state.expand ? state.editable ? "expand plus" : "expand" : ""
      ]))
    }, "1", component, null, 1);

  Row_tag({
      class: "h-100 m-0",
      col: [
          {
              class: "col h-100 p-0 overflow-hidden",
              renderBody: function(out) {
                out.be("div", marko_attrs2, "4", component);

                Locale_tag({
                    text: "Original Content",
                    notrack: true,
                    class: "font-medium-2 text-primary"
                  }, out, __component, "5");

                if ((!state.editable) && state.tosave) {
                  out.be("button", marko_attrs4, "6", component, null, 0, {
                      onclick: __component.d("click", "onSave", false)
                    });

                  Locale_tag({
                      text: "Save",
                      notrack: true
                    }, out, __component, "7");

                  Preloader_tag({
                      active: state.saving,
                      class: "font-medium-3 px-50 float-right"
                    }, out, __component, "8");

                  out.ee();
                }

                out.ee();

                out.be("div", marko_attrs3, "9", component);

                if (Array.isArray(state.DCR) && state.DCR.length) {
                  out.be("ul", marko_attrs5, "10", component);

                  var $for$0 = 0;

                  marko_forOf(state.DCR, function(text, index) {
                    var $keyScope$0 = "[" + (($for$0++) + "]");

                    out.be("li", {
                        "class": marko_classValue(marko_classValue([
                          "nav-item cursor-pointer px-2 py-1 border-bottom font-medium-1",
                          state.editable == text ? "active" : ""
                        ]))
                      }, "11" + $keyScope$0, component, null, 1, {
                        onclick: __component.d("click", "onEdit", false, [
                            text
                          ])
                      });

                    out.be("span", null, "12" + $keyScope$0, component);

                    out.h(text, component);

                    out.ee();

                    if (state.newRecords.includes(text)) {
                      Bx_tag({
                          bxs: true,
                          type: "circle",
                          class: "font-small-2 float-right text-primary py-25"
                        }, out, __component, "13" + $keyScope$0);
                    }

                    out.ee();
                  });

                  out.ee();
                } else {
                  out.be("div", marko_attrs6, "14", component);

                  out.be("div", marko_attrs7, "15", component);

                  Locale_tag({
                      text: "No Record",
                      notrack: true
                    }, out, __component, "16");

                  out.ee();

                  out.ee();
                }

                out.ee();

                if ((state.loading || state.error) || state.counter) {
                  out.be("div", {
                      "class": marko_classValue(marko_classValue([
                        "position-absolute bottom-0 w-100 shadow-lg",
                        state.error ? "danger" : "theme-bg"
                      ]))
                    }, "17", component, null, 1);

                  out.be("div", marko_attrs8, "18", component);

                  if (state.loading) {
                    Preloader_tag({
                        active: true,
                        class: "font-medium-5 px-2"
                      }, out, __component, "19");

                    Locale_tag({
                        text: state.loading,
                        notrack: true
                      }, out, __component, "20");
                  } else if (state.error) {
                    Locale_tag({
                        text: state.error,
                        notrack: true,
                        class: "white-text"
                      }, out, __component, "21");
                  } else {
                    out.t(state.counter, component);

                    out.t(" ");

                    Locale_tag({
                        text: "New records collected",
                        notrack: true,
                        class: "px-50"
                      }, out, __component, "22");
                  }

                  out.ee();

                  out.ee();
                }
              }
            },
          {
              class: marko_classValue([
                "col-6 h-100 border-left p-0",
                !state.editable ? "d-none" : ""
              ]),
              renderBody: function(out) {
                out.be("div", marko_attrs9, "24", component);

                Locale_tag({
                    text: "Translation",
                    notrack: true,
                    class: "font-medium-2 text-primary"
                  }, out, __component, "25");

                if (state.tosave) {
                  out.be("button", marko_attrs14, "26", component, null, 0, {
                      onclick: __component.d("click", "onSave", false)
                    });

                  Locale_tag({
                      text: "Save",
                      notrack: true
                    }, out, __component, "27");

                  Preloader_tag({
                      active: state.saving,
                      class: "font-medium-3 px-50 float-right"
                    }, out, __component, "28");

                  out.ee();
                }

                out.ee();

                out.be("div", marko_attrs10, "29", component);

                out.be("div", marko_attrs11, "30", component);

                Row_tag({
                    style: "height:15%",
                    class: "m-0 d-flex align-items-center",
                    col: [
                        {
                            class: "col-6 pl-0 pr-2",
                            renderBody: function(out) {
                              out.be("label", marko_attrs15, "33", component);

                              Locale_tag({
                                  text: "Language",
                                  notrack: true
                                }, out, __component, "34");

                              out.ee();

                              Select_tag({
                                  class: "rounded",
                                  name: "availability",
                                  value: state.language.locale,
                                  options: Languages.map( ({ locale, name }) => { return { label: name, value: locale } } ),
                                  placeholder: " "
                                }, out, __component, "35", [
                                [
                                  "select",
                                  "onSelect",
                                  false,
                                  [
                                      "locale"
                                    ]
                                ]
                              ]);
                            }
                          },
                        {
                            class: "col-6 pl-2 pr-0",
                            renderBody: function(out) {
                              out.be("label", marko_attrs16, "37", component);

                              Locale_tag({
                                  text: "Variant",
                                  notrack: true
                                }, out, __component, "38");

                              out.ee();

                              Select_tag({
                                  class: "rounded",
                                  name: "availability",
                                  value: state.activeVariant,
                                  options: state.variants.map( ({ id, name }) => { return { value: id } } ),
                                  placeholder: " "
                                }, out, __component, "39", [
                                [
                                  "select",
                                  "onSelect",
                                  false,
                                  [
                                      "variant"
                                    ]
                                ]
                              ]);
                            }
                          }
                      ]
                  }, out, __component, "31");

                out.be("div", marko_attrs12, "40", component);

                out.be("label", marko_attrs13, "41", component);

                Locale_tag({
                    text: "Translation",
                    notrack: true
                  }, out, __component, "42");

                out.ee();

                out.e("textarea", {
                    type: "text",
                    name: "description",
                    value: state.translation,
                    style: marko_styleValue({
                        height: "90%",
                        resize: "none"
                      }),
                    "class": "form-control form-control-lg"
                  }, "43", component, 0, 0, {
                    onchange: __component.d("change", "onTranslateChange", false)
                  });

                out.ee();

                out.ee();

                out.ee();
              }
            }
        ]
    }, out, __component, "2");

  out.ee();

  out.ee();

  out.be("div", marko_attrs1, "44", component, null, 0, {
      onclick: __component.d("click", "onExpand", false)
    });

  Locale_tag({
      text: "Translate",
      notrack: true,
      class: "font-medium-3 white-text px-1"
    }, out, __component, "45");

  if ((!state.expand) && state.loading) {
    Preloader_tag({
        active: true,
        class: "font-medium-5 white-text"
      }, out, __component, "46");
  } else if (state.counter) {
    out.e("div", marko_attrs17, "47", component, 1)
      .e("div", marko_attrs18, "48", component, 1)
        .e("div", marko_attrs19, "49", component, 1)
          .t(state.counter, component);
  }

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
